import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { currencyFormat, IsNotNullOrEmptyOrUndefined } from '../../util';

import ReactTooltip from 'react-tooltip';
import { Icon, Container } from 'semantic-ui-react';

import { unidadMedida } from '../../catalogos';

const LineasDetalle = (props) => {
  const { lineaDetalle, detalleSeleccionado, eliminarDetalle } = props;

  const getUnidad = (value) => {

    if (IsNotNullOrEmptyOrUndefined(value)) {
      return unidadMedida.filter((item) => item.value === value)[0].display;
    }
    return 'N/A';
  };

  useEffect(() => {
    detalleSeleccionado(null);
  }, [lineaDetalle]);

  return (
    <Container className="ui row fluid">
      <div className="ui column">
        <div className="inventario-section">
          <table className="ui compact table" >
            <thead>
              <tr>
                <th data-tip="Cantidad" data-place="right">Cant< ReactTooltip /></th>
                <th className="desktop">Cod. Cabys</th>
                <th className="desktop">Cod. Producto</th>
                <th>Descripción</th>
                <th>U/Medida</th>
                <th className="align-right">Precio Unitario</th>
                <th className="align-right">I.V.A</th>
                <th className="align-right desktop">Exonerado</th>
                <th className="align-right desktop">Descuento</th>
                <th className="align-right">Total_Linea</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {lineaDetalle && lineaDetalle.map((item) => (
                <tr key={item?.NumeroLinea}>
                  <td><span>{item?.Cantidad}</span></td>
                  <td className='texto desktop'><p className='text-short'>{item?.Codigo}</p></td>
                  <td className='texto desktop'><span>{item?.CodigoComercial?.Codigo}</span></td>
                  <td className='texto'>{item?.Detalle}</td>
                  <td className='texto' data-tip={getUnidad(item.UnidadMedida)} data-place="right"><span>{item.UnidadMedida}</span>< ReactTooltip /></td>
                  <td className='numero'>{currencyFormat(item?.PrecioUnitario, 1, '')}</td>
                  <td className='numero'>{currencyFormat(item?.Impuestos?.Impuesto[0]?.Monto, 1, '')}<span className='tarifa-impuesto'>{item?.Impuestos?.Impuesto[0]?.Tarifa}%</span></td>
                  <td className='numero desktop'>{IsNotNullOrEmptyOrUndefined(item?.Impuestos?.Impuesto[0]?.Exoneracion) ? currencyFormat(item?.Impuestos?.Impuesto[0]?.Exoneracion?.MontoExoneracion, 1, '') : currencyFormat(parseFloat(0).toFixed(3), 1, '')}</td>
                  <td className='numero desktop'>{IsNotNullOrEmptyOrUndefined(item?.Descuentos?.Descuento[0]?.MontoDescuento) ? currencyFormat(item?.Descuentos?.Descuento[0]?.MontoDescuento, 1, '') : currencyFormat(parseFloat(0).toFixed(3), 1, '')}</td>
                  <td className='numero'>{currencyFormat(item?.MontoTotalLinea, 2, '')} </td>
                  <td className="editar-column"  ><Icon data-tip="Editar" onClick={() => detalleSeleccionado(item)} className="editar-producto" name="edit" />
                    <Icon data-tip="Eliminar" onClick={() => eliminarDetalle(item)} className="eliminar-producto" name="trash" />< ReactTooltip /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    lineaDetalle: state.localFormState?.DetalleServicio?.LineaDetalle,
  };
}

export default connect(mapStateToProps, {})(LineasDetalle);
